export const SET_STAFF_DETAILS = "SET_STAFF_DETAILS";
export const SET_CARD_DETAILS = "SET_CARD_DETAILS";
export const MAKE_CARD_DEFAULT = "MAKE_CARD_DEFAULT";
export const DEL_CARD_DETAILS = "DEL_CARD_DETAILS";
export const SHOW_CARDDETAILS_SKELETEN = "SHOW_CARDDETAILS_SKELETEN";
export const HIDE_CARDDETAILS_SKELETEN = "HIDE_CARDDETAILS_SKELETEN";
